import React, { useEffect, useState } from "react";
import { Row, Col } from "antd";
import { useDispatch, useSelector } from "react-redux";
import apis from "../../../services/Apis";
import { SecurePost } from "../../../services/axiosCall";
import Alert from "../../common/alert";
import "./conducttes.css";

const Questions = ({ id, updateQuestiosnTest,questionsOfTest }) => {
  const [loading, setLoading] = useState(false);
  const dispatch = useDispatch();

  useEffect(() => {
    refreshQuestionList();
  }, []);

  const refreshQuestionList = () => {
    setLoading(true);
    SecurePost({
      url: `${apis.GET_TEST_QUESTIONS}`,
      data: { id },
    })
      .then((response) => {
        if (response.data.success) {
          dispatch(updateQuestiosnTest(response.data.data));
        }
        setLoading(false);
      })
      .catch((error) => {
        const message = error.response
          ? error.response.data.message
          : error.message;
        Alert("error", "Error!", message);
        setLoading(false);
      });
  };

  const aMap = ["A", "B", "C", "D", "E"];
  const path = apis.BASE_LOCAL_URL;

  return (
    <div style={{overflowX:"hidden"}}>
      {questionsOfTest &&
        questionsOfTest.map((d, i) => {
          const image =
            d.quesimg && d.quesimg.split("www.leagueonline.sg:5000");
          const extension = !d.quesimg
            ? ""
            : image && image[0] === "https://"
            ? image[1].split(".").pop().toLowerCase()
            : d.quesimg.split(".").pop().toLowerCase();

          const isImage = ["jpg", "jpeg", "png", "gif", "bmp"].includes(
            extension
          );
          const isVideo = ["mp4", "avi", "mov", "mkv"].includes(extension);

          return (
            <div key={i} style={{ paddingBottom: "50px" }}>
              <Row>
                <Col span={20}>
                  <b>Q {i + 1})&nbsp;</b>
                  <div dangerouslySetInnerHTML={{ __html: d.body }}></div>
                  <br />
                  {d.quesimg && (
                    <div className="questionDetailsImageContainer">
                      {isImage ? (
                        image && image[0] === "https://" ? (
                          <img src={path + image[1]} className="image-tag" />
                        ) : (
                          <img
                            src={path + "/" + d.quesimg}
                            className="image-tag"
                          />
                        )
                      ) : isVideo ? (
                        image && image[0] === "https://" ? (
                          <video className="image-tag" controls>
                            <source src={path + image[1]} type="video/mp4" />
                          </video>
                        ) : (
                          <video className="image-tag" controls>
                            <source
                              src={path + "/" + d.quesimg}
                              type="video/mp4"
                            />
                          </video>
                        )
                      ) : null}
                    </div>
                  )}
                </Col>
                <Col span={4}>This question is worth: {d.weightage}</Col>
                <Col span={20}>
                  {d.options &&
                    d.options.map((dd, ii) => (
                      <Col key={ii} span={12} style={{ padding: "10px 20px" }}>
                        <b>{aMap[ii]}) </b> {dd.optbody}
                        {dd.optimg && (
                          <img
                            crossOrigin="anonymous"
                            className="questionDetailsImage"
                            width="200"
                            height="200"
                            alt="Option"
                            style={{ marginLeft: "12px" }}
                            src={dd.optimg}
                          />
                        )}
                      </Col>
                    ))}
                </Col>
              </Row>
            </div>
          );
        })}
    </div>
  );
};

export default Questions;
